module.exports = __webpack_public_path__ + "img/OIP-C.5ae4ed14.jpg";